// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wDCJZ","emptyMessage":"styles_emptyMessage__eyA7j"};